import { c as _c } from "react/compiler-runtime";
import { HotelSearchPanel } from "@website/accommodation-ui/hotel-search/hotel-search-panel";
import { HotelSearchSummary } from "@website/accommodation-ui/hotel-search/hotel-search-summary";
import { HotelSearchWrapper } from "@website/accommodation-ui/hotel-search/hotel-search-wrapper";
import { HotelSearchPropertiesType } from "@website/accommodation-ui/hotel-search/hotel-search.types";
import { MaterialIcon } from "@website/icons/material";
import { Button } from "@website/ui/button";
import { useFilters } from "@website/widget/filter";
import { useRouter } from "next/router";
import { FC } from "react";
export const HotelSearch: FC<HotelSearchPropertiesType> = properties => {
  const $ = _c(31);
  const {
    isSearchPanelOpen,
    setIsSearchPanelOpen,
    searchPanelProperties,
    searchSummaryProperties,
    searchType: t0,
    filterProps,
    isFloatCloseButton
  } = properties;
  const searchType = t0 === undefined ? "city" : t0;
  const router = useRouter();
  let t1;
  if ($[0] !== router.pathname) {
    t1 = router.pathname?.includes("map");
    $[0] = router.pathname;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const isMapPage = t1;
  let t2;
  if ($[2] !== filterProps?.schema) {
    t2 = filterProps?.schema ?? {};
    $[2] = filterProps?.schema;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = {
      schema: t2
    };
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const {
    selectedFiltersCount
  } = useFilters(t3);
  const hasSelectedFilters = selectedFiltersCount > 0;
  let t4;
  if ($[6] !== filterProps?.toggleFilterModal || $[7] !== hasSelectedFilters || $[8] !== isMapPage) {
    t4 = isMapPage && <Button className="!ms-4 block !size-8 !overflow-visible md:!hidden" color={hasSelectedFilters ? "secondary" : "neutral"} onClick={filterProps?.toggleFilterModal} variant="text"><span className="relative flex size-8 items-center justify-center">{hasSelectedFilters && <span className="bg-secondary absolute -left-0.5 top-0 size-[8px] rounded-full" />}<MaterialIcon className="text-headline-5" name="tune" /></span></Button>;
    $[6] = filterProps?.toggleFilterModal;
    $[7] = hasSelectedFilters;
    $[8] = isMapPage;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== isFloatCloseButton || $[11] !== searchPanelProperties || $[12] !== searchType) {
    t5 = <HotelSearchPanel {...searchPanelProperties} hasBtnClose={true} isFloatCloseButton={isFloatCloseButton} searchType={searchType} />;
    $[10] = isFloatCloseButton;
    $[11] = searchPanelProperties;
    $[12] = searchType;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== searchSummaryProperties || $[15] !== searchType) {
    t6 = <HotelSearchSummary {...searchSummaryProperties} searchType={searchType} />;
    $[14] = searchSummaryProperties;
    $[15] = searchType;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== isSearchPanelOpen || $[18] !== searchType || $[19] !== setIsSearchPanelOpen || $[20] !== t5 || $[21] !== t6) {
    t7 = <div className="min-w-0 flex-1"><HotelSearchWrapper PanelElement={t5} SummaryElement={t6} isSearchPanelOpen={isSearchPanelOpen} searchType={searchType} setIsSearchPanelOpen={setIsSearchPanelOpen} /></div>;
    $[17] = isSearchPanelOpen;
    $[18] = searchType;
    $[19] = setIsSearchPanelOpen;
    $[20] = t5;
    $[21] = t6;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  const t8 = `${isMapPage ? "!me-6 block size-[18px] md:!hidden" : "!hidden"}`;
  const t9 = filterProps?.onCloseMap;
  let t10;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <MaterialIcon className="text-headline-5" name="close" />;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== t8 || $[25] !== t9) {
    t11 = <Button className={t8} color="neutral" onClick={t9} variant="text">{t10}</Button>;
    $[24] = t8;
    $[25] = t9;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== t11 || $[28] !== t4 || $[29] !== t7) {
    t12 = <div><div className="flex flex-row items-center gap-0 bg-white">{t4}{t7}{t11}</div></div>;
    $[27] = t11;
    $[28] = t4;
    $[29] = t7;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  return t12;
};